export default __webpack_public_path__ + "static/media/filterVariant.296caae9.svg";